// ./src/hooks/useRedeemerOnly.ts
//
// Is the viewer a stall's VOUCHER REDEEMER — whose only page is Redeem Vouchers (owner, 2026-10-18: "they cannot see any
// other pages … a person from a venue who should not have access to anything else") — and for which event?
//   • on an event, its crew role decides (myEventAccess — the server reads it from the live crew row);
//   • elsewhere, a password-crew session's role is the hint stored at sign-in (a person with no account has no pages of
//     their own — every other page would sit empty).
// An account user who redeems on ONE event is not held anywhere else: their own account's pages stay theirs.
import { useCrewAccess } from "@/contexts/CrewAccessContext/CrewAccessContext";
import { CrewSessionService } from "@/utils/api";
import { VOUCHER_REDEEMER_ROLE } from "@/utils/crewLanding";

export const useRedeemerOnly = (): { redeemerOnly: boolean; eventId: string | null } => {
  const { isCrewMode, role, eventId } = useCrewAccess();

  if (isCrewMode) {
    return role === VOUCHER_REDEEMER_ROLE ? { redeemerOnly: true, eventId } : { redeemerOnly: false, eventId: null };
  }

  if (CrewSessionService.hasSession() && CrewSessionService.getRole() === VOUCHER_REDEEMER_ROLE) {
    return { redeemerOnly: true, eventId: CrewSessionService.getEventId() };
  }

  return { redeemerOnly: false, eventId: null };
};
